function Note(aUserId, aContent) {
    "use strict";

    this.__type = 'Note:www.veritracks.com';
    this.Id = -1;
    this.Content = aContent;
    this.CreatedDateUTC = (new Date()).toWcf();
    this.UserId = aUserId;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = Note;
}